import { Router } from '@angular/router';
import { LocalStorageService, SessionStorageService } from "ngx-webstorage";
import * as i0 from "@angular/core";
import * as i1 from "@angular/router";
import * as i2 from "ngx-webstorage/dist/services/localStorage";
import * as i3 from "ngx-webstorage/dist/services/sessionStorage";
var AuthSuccessGuard = /** @class */ (function () {
    function AuthSuccessGuard(_router, localStorage, sessionStorage) {
        this._router = _router;
        this.localStorage = localStorage;
        this.sessionStorage = sessionStorage;
        this.token = this.localStorage.retrieve('authenticationToken') || this.sessionStorage.retrieve('authenticationToken');
    }
    AuthSuccessGuard.prototype.canActivate = function (next, state) {
        if (!this.token) {
            return true;
        }
        else {
            this._router.navigate(['/dashboard/home']);
            return false;
        }
    };
    AuthSuccessGuard.ngInjectableDef = i0.defineInjectable({ factory: function AuthSuccessGuard_Factory() { return new AuthSuccessGuard(i0.inject(i1.Router), i0.inject(i2.LocalStorageService), i0.inject(i3.SessionStorageService)); }, token: AuthSuccessGuard, providedIn: "root" });
    return AuthSuccessGuard;
}());
export { AuthSuccessGuard };
